import { render, staticRenderFns } from "./BidDate.vue?vue&type=template&id=88d79478&scoped=true&"
import script from "./BidDate.vue?vue&type=script&lang=js&"
export * from "./BidDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d79478",
  null
  
)

export default component.exports